import React from "react"
import { Box } from "@chakra-ui/react"
import Link from "components/elements/Link"
import UpgradeAlert from "components/elements/UpgradeAlert"
import { SubscriptionType } from "sharedTypes"
import { TEXT_MESSAGING_ARTICLE_LINK } from "utilities/externalLinks"

const TextUpgradeAlert = () => (
  <UpgradeAlert
    title="Upgrade to Enterprise to Unlock SMS & WhatsApp Messaging Features"
    text={(
      <>
        Create personalized text campaigns using Meta-approved templates ready for
        instant distribution. Built-in workflows and WhatsApp Fallback to SMS help
        improve delivery and guest engagement.
        <Box mt={2}>
          Learn more:{" "}
          <Link href={TEXT_MESSAGING_ARTICLE_LINK} target="_blank">
            Overview of SMS and WhatsApp Messaging in Diobox
          </Link>
        </Box>
      </>
    )}
    defaultSelectedPlan={SubscriptionType.Enterprise}
  />
)

export default TextUpgradeAlert
